import { FC } from "react";
import styles from "./Title.module.scss";

interface IMainTitleProps {
  text: string;
  type: "main" | "big" | "default" | "small";
}

export const Title: FC<IMainTitleProps> = ({ text, type }) => {
  switch (type) {
    case "main":
      return (
        <h1 className={`${styles.contentTitle} ${styles.main}`}>{text}</h1>
      );
    case "big":
      return <h2 className={`${styles.contentTitle} ${styles.big}`}>{text}</h2>;
    case "default":
      return (
        <h3 className={`${styles.contentTitle} ${styles.default}`}>{text}</h3>
      );
    case "small":
      return (
        <h4 className={`${styles.contentTitle} ${styles.small}`}>{text}</h4>
      );

    default:
      return <></>;
  }
};
